"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _createSvgIcon.default)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m9.6 5.2 2-2.67c.2-.27.6-.27.8 0l2 2.67c.25.33.01.8-.4.8h-1v4.17l-2-2V6h-1c-.41 0-.65-.47-.4-.8m5.9 6.8h.5v1.17l1.77 1.77c.14-.28.23-.6.23-.94v-2h.5c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-3c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5m4.99 9.9c-.39.39-1.02.39-1.41 0l-5.9-5.9H13v2.28c.6.34 1 .98 1 1.72 0 1.2-1.07 2.16-2.31 1.98-.88-.13-1.59-.88-1.68-1.77-.08-.83.33-1.55.99-1.93V16H8c-1.1 0-2-.9-2-2v-2.28c-.6-.34-1-.98-1-1.72 0-.59.26-1.13.68-1.5L2.1 4.93a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0l16.97 16.97c.4.39.4 1.02.01 1.41M11 13.83l-2.51-2.51c-.14.16-.31.29-.49.4V14h3z"
}), 'UsbOffRounded');